import styled from '@emotion/styled/macro';

import { OverviewHeader } from '../../../../../styledComponents/OverviewPage/OverviewPageHeader';

export const StyledOverviewHeader = styled(OverviewHeader)`
  margin-left: 0;
  margin-right: 0;
`;
